import React from 'react';

import { Box, Tab, Tabs } from '@mui/material';

type NavTabsProps = {
  value: number;
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  pages: { name: string }[];
};

export const NavTabs = (props: NavTabsProps) => {
  return (
    <Box
      sx={{
        ml: '15px',
        alignSelf: 'stretch',
        flexGrow: 1,
        display: { xs: 'none', md: 'flex' },
      }}
    >
      <Tabs
        value={props.value}
        onChange={props.handleTabChange}
        textColor="inherit"
        indicatorColor="primary"
        centered
        slotProps={{ indicator: { sx: { height: 4 } } }}
        aria-label="navigation tabs"
      >
        {props.pages.map((page) => (
          <Tab key={page.name} label={page.name} sx={{ typography: 'h6', marginTop: '3px' }} />
        ))}
      </Tabs>
    </Box>
  );
};
